export default __webpack_public_path__ + "static/media/logo_vwcomerciales_kmi_m_sep20.a4a9c8fc.png";